export default {
  en: {
    tabs: {
      dashboard: 'Dashboard',
      suppliers: 'Suppliers',
    },
    threatPage: {
      pageTitle: 'Emerging Threats - {0}',
      title: 'Emerging Threats',
      errorFetching:
        'There was an error fetching the Emerging Threat information. Please try again.',
      retry: 'Retry',
      supplierList: {
        export: 'Export',
        exportError: 'There was an error attempting to export the current Emerging Threats',
        exportTitle: 'Supplier-Emerging-Threat-List',
        placeholders: {
          emptyTitle: 'Suppliers',
          emptyDescription: 'No suppliers matching the filters.',
          errorTitle: 'Suppliers',
          errorDescription: 'Failed fetching suppliers',
        },
        dataTableColumns: {
          name: 'Supplier name',
          responseStatus: 'Status',
          respondedAt: 'Date responded',
          modifiedAt: 'Last updated',
          location: 'Location',
          criticality: 'Criticality',
          confidentiality: 'Confidentiality',
          holdsPII: 'Holds PII',
          labels: 'Labels',
          sector: 'Sector',
          assignedUsers: 'Assigned users',
          question: 'Question {0}',
        },
        entityName: 'Supplier',
        searchPlaceholder: 'Search suppliers',
        filterAttributes: {
          name: 'Name',
          responseStatus: 'Status',
          respondedAt: 'Date responded',
          modifiedAt: 'Last updated',
          location: 'Location',
          criticality: 'Criticality',
          confidentiality: 'Confidentiality',
          holdsPII: 'Holds PII',
          labels: 'Labels',
          sector: 'Sector',
          assignedUsers: 'Assigned users',
          assignedToMe: 'Assigned to me',
          assignedToMeTrue: 'is assigned to me',
          assignedToMeFalse: 'is not assigned to me',
          questionNotes: 'Question {0} notes',
          questionEvidence: 'Question {0} evidence',
          questionAnswer: 'Question {0} answer',
          hasNotes: 'has notes for question {0}',
          hasNotesFalse: 'does not have notes for question {0}',
          hasEvidence: 'has evidence for question {0}',
          hasEvidenceFalse: 'does not have evidence for question {0}',
        },
        dataTable: {
          deletedUser: 'Deleted user',
        },
      },
    },
    threatList: {
      title: 'Emerging Threats',
      pageTitle: 'Emerging Threats',
      placeholders: {
        errorTitle: 'Emerging Threats',
        errorDescription: 'Failed fetching Emerging Threats',
        emptyTitle: 'No matching threats',
        emptyDescription: 'Try a different search or filter',
      },
      dataTableColumns: {
        name: 'Emerging Threat name',
        type: 'Type',
        status: 'Status',
        emergedAt: 'Date emerged',
        remediatingSuppliers: 'Suppliers remediating',
        unansweredSuppliers: 'Suppliers not responded',
        investigatingSuppliers: 'Suppliers investigating',
        resolvedSuppliers: 'Suppliers resolved',
        unaffectedSuppliers: 'Suppliers unaffected',
      },
      tooltips: {
        notes: 'Includes notes',
        evidence: 'Includes evidence',
      },
      filters: {
        entityName: 'Emerging Threats',
        searchPlaceholder: 'Search threats',
      },
      export: 'Export',
      exportError: 'There was an error attempting to export the current threats',
      questionAnswers: {
        yes: 'Yes',
        no: 'No',
        unanswered: 'Unanswered',
      },
    },
    dashboard: {
      questionResponses: 'Responses',
      specificQuestion: 'Question {0}',
      yes: 'Yes',
      no: 'No',
      unanswered: 'Unanswered',
      supplierStatusTitle: 'Statuses',
      filterBy: 'Filter by: {tag}',
      none: 'None',
    },
    supplierStatusCard: {
      change: '{change} in the past 24hrs',
      noChange: 'No change',
    },
    placeholder: {
      title: 'Introducing Emerging Threats',
      description:
        'There are no Emerging Threats right now and there is nothing you need to do. In the future, Risk Ledger will publish Emerging Threats to the network and you will be able to see which of your suppliers have been affected. To learn more watch the video below.',
      buttonCTA: 'Watch video',
      or: 'Or',
      readMore: 'read more on our blog',
    },
    trialPlaceholder: {
      title: 'Stay ahead of security risks across your supply chain',
      description:
        'Gain critical insights about Emerging Threats affecting your suppliers and take coordinated action to protect your organization before impact escalates.',
      title2: 'Key benefits',
      benefit1: 'Gain visibility into how vulnerabilities affect your entire supply chain',
      benefit2: 'Cut through the noise with focused assessments on threats that matter most',
      benefit3: 'Receive actionable recommendations to mitigate risks proactively',
      benefit4: 'Stay informed about regulatory changes impacting security requirements',
      cta: 'Book a demo',
    },
  },
};
